import { Dialog, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { useState } from 'react';

const useStyles = makeStyles({
  paper: { maxWidth: '92vw', maxHeight: '92vh', cursor: 'zoom-out', padding: 12 },
  // A light checkerboard under the image shows what is transparent.
  board: {
    backgroundColor: '#fff',
    backgroundImage:
      'linear-gradient(45deg, #e6e6e6 25%, transparent 25%), linear-gradient(-45deg, #e6e6e6 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #e6e6e6 75%), linear-gradient(-45deg, transparent 75%, #e6e6e6 75%)',
    backgroundSize: '20px 20px',
    backgroundPosition: '0 0, 0 10px, 10px -10px, -10px 0',
    display: 'flex',
    justifyContent: 'center',
  },
  image: { display: 'block', maxWidth: '88vw', maxHeight: '80vh', objectFit: 'contain' },
  caption: { marginTop: 8, textAlign: 'center', color: '#555' },
});

// An image shown big, on a checkerboard, with its name and real size; any click or Escape closes it.
// `children` replace the image for what is drawn rather than loaded (a template), with its `size` given.
const ImageZoom = ({ src, label, open, onClose, children, size: givenSize }) => {
  const classes = useStyles();
  const [loadedSize, setSize] = useState(null);
  const size = givenSize || loadedSize;
  const close = (event) => {
    event?.stopPropagation?.();
    onClose();
  };

  return (
    <Dialog open={open} onClose={close} maxWidth={false} classes={{ paper: classes.paper }} onClick={close}>
      <div className={classes.board}>
        {children || <img src={src} alt={label || ''} className={classes.image} onLoad={(e) => setSize({ w: e.target.naturalWidth, h: e.target.naturalHeight })} />}
      </div>
      <Typography variant="body2" className={classes.caption}>
        {[label, size && `${size.w} × ${size.h}`].filter(Boolean).join(' — ')}
      </Typography>
    </Dialog>
  );
};

ImageZoom.propTypes = {
  src: PropTypes.string,
  label: PropTypes.string,
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node,
  size: PropTypes.shape({ w: PropTypes.number, h: PropTypes.number }),
};

export default ImageZoom;
